import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedChannelSelectionStepWithI18n } from './delayed-channel-selection-step';

export const ChannelSelectionStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.CHANNEL_SELECTION,
  view: DelayedChannelSelectionStepWithI18n,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
    guards: {
      needsLoading: () => false,
      needsSaving: () => false,
    },
  },
};
